
export default {
  props: {
    articleData: {
      type: Array,
      default: []
    },
    xl: {
      type: Number,
      default: ''
    },
    lg: {
      type: Number,
      default: ''
    },
    md: {
      type: Number,
      default: ''
    },
    sm: {
      type: Number,
      default: ''
    },
    isArticleListReady: {
      type: Boolean,
      default: false
    },
    isEmptyPage: {
      type: Boolean,
      default: false
    },
  }
}
